import * as Actions from '../../actions/appointment/types';

// add appointment

export const AddAppointmentReducer = (state = {}, action) => {
  switch (action.type) {
    case Actions.ADD_APPOINTMENT_REQUEST:
      return { loading: true };
    case Actions.ADD_APPOINTMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        newAppointment: action.payload.data || '',
      };
    case Actions.ADD_APPOINTMENT_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case Actions.CLEAR_ADD_APPOINTMENT_MESSAGES:
      return {
        ...state,
        loading: false,
        error: '',
        newAppointment: '',
      };
    default:
      return state;
  }
};

// update appointment

export const UpdateAppointmentReducer = (state = {}, action) => {
  switch (action.type) {
    case Actions.UPDATE_APPOINTMENT_REQUEST:
      return {
        updateAppointmentLoading: !action.payload?.isDeleted,
        deleteAppointmentLoading: action.payload?.isDeleted,
      };
    case Actions.UPDATE_APPOINTMENT_SUCCESS:
      return {
        ...state,
        updateAppointmentLoading: false,
        deleteAppointmentLoading: false,
        updatingAppointment: action.payload || '',
      };
    case Actions.UPDATE_APPOINTMENT_FAIL:
      return {
        ...state,
        updateAppointmentLoading: false,
        deleteAppointmentLoading: false,
        error: action.payload,
      };
    case Actions.CLEAR_UPDATE_APPOINTMENT_MESSAGES:
      return {
        ...state,
        updateAppointmentLoading: false,
        deleteAppointmentLoading: false,
        error: '',
        updatingAppointment: '',
      };
    default:
      return state;
  }
};

// get appointments

export const GetAppointmentsReducer = (state = {}, action) => {
  switch (action.type) {
    case Actions.GET_APPOINTMENTS_REQUEST:
      return { ...state, loading: true };
    case Actions.GET_APPOINTMENTS_SUCCESS:
      return {
        ...state,
        loading: false,
        appointments: action.payload,
      };
    case Actions.GET_APPOINTMENTS_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case Actions.UPDATE_APPOINTMENTS:
      return {
        ...state,
        loading: false,
        appointments: action.payload,
      };
    default:
      return state;
  }
};

// get appointment

export const GetAppointmentReducer = (state = {}, action) => {
  switch (action.type) {
    case Actions.GET_APPOINTMENT_REQUEST:
      return { loading: true };
    case Actions.GET_APPOINTMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        appointment: action.payload,
      };
    case Actions.GET_APPOINTMENT_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};
